import categoryAngles from './category-angles.json';

const getProductImageAngle = ({ product }) => {
  if (!product) {
    return 1;
  }
  const productTypeName =
    typeof product.type === 'string' ? product.type : product.type?.name;
  const productAngle = product.defaultAngle
    ? product.defaultAngle
    : !!productTypeName && categoryAngles[productTypeName.toLowerCase()]
    ? categoryAngles[productTypeName.toLowerCase()]
    : 1;

  return productAngle;
};

export default getProductImageAngle;
